// Конфигурация API
export const API_BASE_URL = '/api';

// Настройки axios по умолчанию для отправки cookies
export const axiosConfig = {
  withCredentials: true // Всегда отправляем cookies
};

